import adminInstructionReducer from '@/admin/pages/instruction/Reducer';
import profileReducer from '@/admin/pages/profile/Reducer';
import adminPlaylistReducer from '@/admin/pages/quiz/Reducer';
import episodesReducer from '@/admin/pages/studyGoBridgeEpisodes/Reducer';
import episodeDetailsReducer from '@/admin/pages/studyGoEpisodeDetails/Reducer';
import roomDetailsReducer from '@/admin/pages/studyGoRoomDetails/Reducer';
import subjectDetailsReducer from '@/admin/pages/subjectDetails/Reducer';
import subjectsReducer from '@/admin/pages/subjects/Reducer';
import topicsReducer from '@/admin/pages/topics/Reducer';
import { reducers } from '@/rootState';

import manageCategoryReducer from '@/admin/components/modals/manageCategory/Reducer';
import manageDifficultyReducer from '@/admin/components/modals/manageDifficulty/Reducer';
import manageEpisodeReducer from '@/admin/components/modals/manageEpisodeModal/Reducer';
import managePlaylistReducer from '@/admin/components/modals/managePlaylist/Reducer';
import manageSubcategoryReducer from '@/admin/components/modals/manageSubcategory/Reducer';
import manageSubjectReducer from '@/admin/components/modals/manageSubject/Reducer';
import manageTopicReducer from '@/admin/components/modals/manageTopic/Reducer';
import sidebarReducer from '@/admin/components/sideBar/Reducer';
import addWysiwygAnswerModalReducer from '@/admin/components/wysiwyg/addAnswer/Reducer';
import addWysiwygFormulaModalReducer from '@/admin/components/wysiwyg/addFormula/Reducer';
import addWysiwygImageModalReducer from '@/admin/components/wysiwyg/addImage/Reducer';
import addWysiwygVideoModalReducer from '@/admin/components/wysiwyg/addVideo/Reducer';

import type { ReducerState, RootStateOverrides } from '@/rootState';

export const adminReducers = {
	...reducers,
	addWysiwygAnswerModalReducer,
	addWysiwygFormulaModalReducer,
	addWysiwygImageModalReducer,
	addWysiwygVideoModalReducer,
	adminInstructionReducer,
	adminPlaylistReducer,
	episodeDetailsReducer,
	episodesReducer,
	manageCategoryReducer,
	manageDifficultyReducer,
	manageEpisodeReducer,
	managePlaylistReducer,
	manageSubcategoryReducer,
	manageSubjectReducer,
	manageTopicReducer,
	profileReducer,
	roomDetailsReducer,
	sidebarReducer,
	subjectDetailsReducer,
	subjectsReducer,
	topicsReducer,
};

export type AdminRootState = {
	[K in keyof typeof adminReducers]: K extends keyof RootStateOverrides
		? RootStateOverrides[K]
		: ReducerState<(typeof adminReducers)[K]>;
};
